import { render, staticRenderFns } from "./ReportMealsTabMeals.vue?vue&type=template&id=65bc9824"
import script from "./ReportMealsTabMeals.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports